import React from 'react';
import {View} from 'react-native';

import ProgressBar from '/component/base/ProgressBar';
import Text from '/component/base/Text';
import {ProfilePage} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {getTextFromReactNode} from '/util/accessibility.util';

import {styles} from './RankProgress.style';
import {RankProgressProps} from './RankProgress.types';
import {getCurrentPercent, getProgressDescription} from './RankProgress.util';

export const RankProgress = ({
  tt = withTranslation.ttDefaultProp,
  percent = 0,
  hasNextRank = true,
}: RankProgressProps) => {
  const descriptionNode = getProgressDescription({tt, percent, hasNextRank});
  const descriptionText = getTextFromReactNode(descriptionNode);

  return (
    <View
      style={styles.base}
      accessible={true}
      accessibilityLabel={descriptionText}>
      <ProgressBar
        variant="thin"
        progress={getCurrentPercent({percent, hasNextRank})}
        style={{
          base: styles.progressBarBase,
          fill: styles.progressBarFill,
        }}
      />
      <Text
        testID={ProfilePage.profileRankProgress}
        style={styles.text}
        emphasis="low"
        allowFontScaling
        maxFontSizeMultiplier={2}>
        {getProgressDescription({tt, percent, hasNextRank})}
      </Text>
    </View>
  );
};

export default withTranslation('userInfo.rankUpProgress')(RankProgress);
